module.exports = __webpack_public_path__ + "static/img/PRODUCT CARD_DOUBLE COATING_mobile.3d5a76c9.jpg";